/* eslint-disable import/prefer-default-export */
import { useCallback, useMemo, useRef } from 'react'
import ReCAPTCHA, { ReCAPTCHAProps } from 'react-google-recaptcha'
import { useRecoilValue } from 'recoil'
import { systemParametersState } from '../store/system-parameters'

const useCaptcha = () => {
  const systemParameters = useRecoilValue(systemParametersState)
  const passedRef = useRef(false)

  const handleRecaptchaChange: Required<ReCAPTCHAProps>['onChange'] =
    useCallback((token) => {
      passedRef.current = !!token
    }, [])

  const isPassed = useCallback(() => {
    return !systemParameters?.is_captcha_enforced_for_lead || passedRef.current
  }, [systemParameters?.is_captcha_enforced_for_lead])

  const render = useCallback(
    () =>
      systemParameters?.is_captcha_enforced_for_lead && (
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY!}
          onChange={handleRecaptchaChange}
        />
      ),
    [handleRecaptchaChange, systemParameters?.is_captcha_enforced_for_lead]
  )

  return useMemo(() => ({ isPassed, render }), [isPassed, render])
}

export { useCaptcha }
